import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose } from 'recompose';

import withSearchHandler from 'decorators/withSearchHandler';
import { H1, H2 } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import './landingHero.scss';

export const enhance = compose(
	withSearchHandler,
);

export function LandingHero({
	className, dark, handleSearch, headline, subheading, children, withSearchBox, withDatePicker,
	searchButtonText
}) {
	return (
		<div className={classnames('landing-hero', className, { dark })}>
			<div className="section-content">
				{!!headline &&
					<H1
						color="white"
						size="huge"
					>
						{headline}
					</H1>
				}
				{!!subheading &&
					<H2
						color="white"
						weight="medium"
						size="medium"
					>
						{subheading}
					</H2>
				}
				{!!withSearchBox &&
					<SearchBox
						withDatePicker={withDatePicker}
						handleSearch={handleSearch}
						buttonText={searchButtonText}
						id="psp-landing-hero-search"
					/>
				}
				{children}
			</div>
		</div>
	);
}

LandingHero.propTypes = {
	searchButtonText: PropTypes.string,
	className: PropTypes.string,
	handleSearch: PropTypes.func,
	headline: PropTypes.node,
	subheading: PropTypes.node,
	children: PropTypes.node,
	dark: PropTypes.bool,
	withSearchBox: PropTypes.bool,
	withDatePicker: PropTypes.bool
};

LandingHero.defaultProps = {
	withSearchBox: true
};

export default enhance(LandingHero);
